export default import.meta.ROLLDOWN_FILE_URL_bRGp5l3nOZD9jNRYAfj65Q